<div class="conversation">
  <!-- A11Y.1 28 Sep: the card opened on click only, so a keyboard could not
       open a saved conversation (2.1.1). The click still bubbles to the
       card, which the list listens on. -->
  <button type="button" class="conversation-text">
    <span class="conversation-header">
      <span class="conversation-title">
        {{ conversation.title }}
      </span>
      <span class="conversation-date">
        @if (conversation.updatedAt.split('T')[0] === today) {
          {{ conversation.updatedAt | localTime: 'time' }}
        } @else {
          {{ conversation.updatedAt | localTime: 'date' }}
        }
      </span>
    </span>
    <span class="conversation-message">
      {{ (conversation.lastMessage | markdownPreview) || conversation.title }}
    </span>
  </button>
  <button
    [attr.aria-label]="'Delete ' + conversation.title"
    type="button"
    class="conversation-button"
    mat-icon-button
    (click)="onDeleteConversation($event)"
  >
    <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
  </button>
</div>
